import { StoreItemPath, Entity, StoreField } from 'app/types-shared';

export const entityValue = (entity: Entity, dataTag: string) => {
  return (
    entity &&
    entity[dataTag] &&
    (entity[dataTag] as StoreField[]).length &&
    (entity[dataTag] as StoreField[])[0].value
  );
};

/**
 * The last item represents the type (subTable)
 *
 * @param entityTypePath The path to the entity in data.
 */
export const getEntityTypeFromPath = (entityTypePath: string[]) => {
  return entityTypePath && entityTypePath[entityTypePath.length - 1];
};

/**
 * The indexer of the last item represents the type (subTable)
 *
 * @param storePath The path to the entity in the store data.
 */
export const getEntityTypeFromStorePath = (storePath: StoreItemPath[]) => {
  return (
    storePath &&
    storePath[storePath.length - 1] &&
    Object.keys(storePath[storePath.length - 1])[0]
  );
};

/**
 * Converts a full entity path containing id's to only return the entity type names, preserving the
 * same order
 */
export const getEntityTypePathFromStorePath = (storePath: StoreItemPath[]) => {
  return (
    storePath && storePath.map(p => p && Object.keys(p)[0]).filter(Boolean)
  );
};

/**
 * Returns the numeric primary key for the entity. If this is a child entity, the entities primary key is returned.
 *
 * @param entity Entity to retrieve the numeric id for
 */
export const getPrimaryEntityId = (entity: Entity): number => {
  if (!entity || !entity.id || !entity.id.length) {
    return undefined;
  }
  const last = entity.id[entity.id.length - 1];
  return last[Object.keys(last)[0]];
};
